module.exports = __webpack_public_path__ + "media/A New Horizon.5aa3ac9e.mp3";